import { z } from 'zod/v4';

import { applicationSettingSchema } from './application-setting.schema';

export const accountApplicationSchema = z.object({
  applicationId: z.number(),
  applicationName: z.string(),
  applicationSettings: z.array(applicationSettingSchema),
});

export type AccountApplication = z.infer<typeof accountApplicationSchema>;
